import React, { useContext, useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import LoaderComponent from '../../components/CommonComponents/LoaderComponent'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'
import { doCreateDomain, doStartUserDomain, doJoinOtherDomain, doGetSameDomainWithName, acceptDomainInvitation, rejectDomainInvitation } from '../../redux/actions/domain'
import LogoImg from '../../assets/svg/logo.svg'
import { AiOutlinePlusCircle } from 'react-icons/ai'
import { RiErrorWarningLine } from 'react-icons/ri'

import { doLogOut } from '../../redux/actions/auth'
import { Redirect } from 'react-router-dom'
import { AppContext } from '../../context'

const DomainSelector = () => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    domain: { myDomains, joinedDomains, isLoading },
    auth: { token, user }
  } = store

  const { clearStates } = useContext(AppContext);


  const [domains, setDomains] = useState([])
  const [joinedMyDomains, setJoinedMyDomains] = useState([])

  const [selectedDomain, setSelectedDomain] = useState(null)

  useEffect(() => {
    if (isLoading) {
      return
    }
    if (!myDomains || myDomains.length === 0) {
      setDomains([])
      return
    }
    setDomains(myDomains)
    setSelectedDomain(myDomains[0])
  }, [isLoading, myDomains])

  useEffect(() => {
    if (isLoading) {
      return
    }
    if (!joinedDomains || joinedDomains.length === 0) {
      setJoinedMyDomains([])
      return
    }
    setJoinedMyDomains(joinedDomains)
  }, [isLoading, joinedDomains])

  const [step, setStep] = useState('select')

  const [existingDomainInfo, setExistingDomainInfo] = useState({})
  const [createStep, setCreateStep] = useState('basic')
  const [isShowPromt, setIsShowPromt] = useState(false)
  const [isGettingDomain, setIsGettingDomain] = useState(false)
  const [isJoiningDomain, setIsJoiningDomain] = useState(false)

  const [domainNameValues, setDomainName] = useState({
    domainName: '',
    domainNameError: ''
  })
  const [companyName, setCompanyName] = useState('')
  const [address1, setAddress1] = useState('')
  const [address2, setAddress2] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [zip, setZip] = useState('')
  const [country, setCountry] = useState('')
  const [url, setUrl] = useState('')
  const [phone, setPhone] = useState('')
  const [industry, setIndustry] = useState('')
  const [companySize, setCompanySize] = useState('')

  const handleSelectDomain = (domain) => {
    setSelectedDomain(domain)
  }
  const handleSelectOtherDomain = (domain) => {
    // if (domain?.userRole?.isActive) {
    setSelectedDomain(domain)
    // }
  }

  const searchDomainWithName = (domainName) => {
    setIsGettingDomain(true)
    dispatch(
      doGetSameDomainWithName({
        domainName
      })
    ).then(res => {
      if (!res.isExisting) {
        setExistingDomainInfo({
          isAlreadyJoined: false,
          existingDomain: null,
        })
        setCreateStep('final')
      }
      if (res.isExisting && res.isJoined) {
        setDomainName({ ...domainNameValues, domainNameError: 'This domain already exists' })
        setExistingDomainInfo({
          isAlreadyJoined: true,
          existingDomain: null,
        })
      } else {
        setDomainName({ ...domainNameValues, domainNameError: '' })
      }
      if (res.isExisting && !res.isJoined) {
        setExistingDomainInfo({
          isAlreadyJoined: false,
          existingDomain: res.domain,
        })
        setIsShowPromt(true)
      }
      setIsGettingDomain(false)
    }).catch(err => {
      setExistingDomainInfo({
        isAlreadyJoined: false,
        existingDomain: null,
      })
      setIsShowPromt(false)
      if (err?.response?.data?.message) {
        toast.show({
          title: 'Warning',
          description: err?.response?.data?.message
        })
      } else {
        toast.show({
          title: 'Warning',
          description: 'Error to get domain!'
        })
      }
      setIsGettingDomain(false)
    })
  }

  const handleCreateDomain = () => {
    if (domainNameValues.domainName === '') {
      domainNameValues.domainNameError = 'Domain name is required'
    } else {
      if (createStep === 'basic') {
        searchDomainWithName(domainNameValues.domainName)
        return
      }
    }

    if (domainNameValues.domainNameError === '') {
      if (companyName === '') {
        toast.show({
          title: 'Warning',
          description: 'Company name is required',
        })
        return
      }
      if (address1 === '' && address2 === '') {
        toast.show({
          title: 'Warning',
          description: 'Address is required',
        })
        return
      }
      if (city === '') {
        toast.show({
          title: 'Warning',
          description: 'City is required',
        })
        return
      }
      if (state === '') {
        toast.show({
          title: 'Warning',
          description: 'State is required',
        })
        return
      }
      if (zip === '') {
        toast.show({
          title: 'Warning',
          description: 'Zip is required',
        })
        return
      }
      if (country === '') {
        toast.show({
          title: 'Warning',
          description: 'Country is required',
        })
        return
      }
      if (url === '') {
        toast.show({
          title: 'Warning',
          description: 'URL is required',
        })
        return
      }
      if (phone === '') {
        toast.show({
          title: 'Warning',
          description: 'Phone is required',
        })
        return
      }
      if (industry === '') {
        toast.show({
          title: 'Warning',
          description: 'Industry is required',
        })
        return
      }
      if (companySize === '') {
        toast.show({
          title: 'Warning',
          description: 'Company size is required',
        })
        return
      }
      dispatch(
        doCreateDomain({
          domainName: domainNameValues.domainName,
          companyName,
          address1,
          address2,
          city,
          state,
          zip,
          country,
          url,
          phone,
          industry,
          companySize
        })
      )
    } else {
      setDomainName({ ...domainNameValues })
    }
  }

  const handleClickStartDomain = (type = 'launch') => {
    if (!selectedDomain) {
      toast.show({
        title: 'Warning',
        description: 'Please select domain you are going to use'
      })
      return
    }

    if (type === 'reject') {
      dispatch(
        rejectDomainInvitation({
          domainId: selectedDomain?.id,
        })
      )
    }

    if (type === 'accept-and-launch') {
      dispatch(
        acceptDomainInvitation({
          domainId: selectedDomain?.id,
        })
      ).then(() => {
        dispatch(
          doStartUserDomain({ domainId: selectedDomain?.id })
        ).then((res) => {
          if (process.env.REACT_APP_ENV !== 'local' && process.env.REACT_APP_ENV !== 'review') {
            if (!window.location.href.includes(res.subdomain)) {
              const authInfo = {
                user: user,
                token: token,
                subdomain: res.subdomain,
                currentDomain: res.domain,
              }
              window.location.assign(res.subdomain + `?${encodeURI(JSON?.stringify(authInfo))}`)
            }
          }
        })
      })
    }

    if (type === 'launch') {
      dispatch(
        doStartUserDomain({ domainId: selectedDomain?.id })
      ).then((res) => {
        if (process.env.REACT_APP_ENV !== 'local' && process.env.REACT_APP_ENV !== 'review') {
          if (!window.location.href.includes(res.subdomain)) {
            const authInfo = {
              user: user,
              token: token,
              subdomain: res.subdomain,
              currentDomain: res.domain,
            }
            window.location.assign(res.subdomain + `?${encodeURI(JSON?.stringify(authInfo))}`)
            // dispatch(doRemoveAuthInfo())
            // dispatch(doRemoveDomainInfo())
          }
        }
      })
    }

  }

  const handleExistingDomain = (domain) => {
    if (domain && domain.id) {
      setIsJoiningDomain(true)
      dispatch(
        doJoinOtherDomain({
          domainId: domain.id,
        })
      ).then(() => {
        setIsJoiningDomain(false)
      }).catch(() => {
        setIsJoiningDomain(false)
      })
    }
  }

  const handleTryAnother = () => {
    setIsShowPromt(false)
    setExistingDomainInfo({})
    setCreateStep('basic')
  }

  const handleDomainNameChange = (event) => {
    if (domainNameValues.domainName !== '') {
      domainNameValues.domainNameError = ''
    }
    if (existingDomainInfo.isAlreadyJoined) {
      setExistingDomainInfo({ ...existingDomainInfo, isAlreadyJoined: false })
    }
    setDomainName({ ...domainNameValues, domainName: event.target.value })
  }

  const isComponnetLoading = isLoading || isGettingDomain || isJoiningDomain

  const onSignout = () => {
    clearStates()
    dispatch(
      doLogOut()
    )
  }

  const handleStartDomain = (type = 'launch') => {
    handleClickStartDomain(type)
  }

  if (!token) {
    localStorage.removeItem('loginStep')
    return <Redirect to='/login' />
  }

  return (
    <div className={`domain-selector ${(createStep === 'final' && step !== 'select') ? '' : 'h-100'} ${isComponnetLoading ? 'loading' : ''}`}>
      {isComponnetLoading && <LoaderComponent />}
      <div className="logo flex align-center justify-space-between">
        <img src={LogoImg} alt="logo" />
        <button type="button" className="btn-logout" onClick={onSignout}>Sign out</button>
      </div>
      <div className='domain-header'>
        <h4>Welcome to Ricochet</h4>
        Choose your domain to start working
      </div>
      {
        step === 'select' && (
          <div className="join">
            <div className="title flex align-center justify-end ">
              <AiOutlinePlusCircle color="#65B3E9" size={24} />
              <span
                className="create-domain-btn fw-bold"
                onClick={() => setStep('create')}
              >
                Create Domain
              </span>
            </div>
            <div className="content">
              <div className="own">
                <div className="list table mb-0">
                  <h3 className='choose-domain'>Choose Domain</h3>
                  <div className="table-body">
                    {
                      domains && domains.length > 0 && domains.map((domain) => (
                        <div className={`table-row ${selectedDomain?.id === domain?.id ? 'selected' : ''}`} key={domain.id} onClick={() => handleSelectDomain(domain)}>
                          <div className='domain-circle p-0'></div>
                          <div className={`domain-and-owner-name p-0 bg-transparent${selectedDomain?.id === domain?.id ? ' text-white' : ''}`}>
                            <h3> {domain?.domainName} </h3>
                            <h4> {domain?.role?.name.charAt(0).toUpperCase() + domain?.role?.name.slice(1)} </h4>
                          </div>
                          <h3 className='domain-status p-0 mb-0 bg-transparent' onClick={selectedDomain?.id === domain?.id ? () => handleClickStartDomain('launch') : () => { }}>
                            Launch
                          </h3>
                        </div>
                      ))
                    }
                    {
                      joinedMyDomains && joinedMyDomains.length > 0 && joinedMyDomains.map((domain) => (
                        <div className={`table-row ${selectedDomain?.id === domain?.id ? 'selected' : ''} ${domain?.userRole?.isInvited ? domain?.userRole?.isActive ? '' : domain?.userRole?.isActive === null ? 'pending-domain' : 'denied-domain' : domain?.userRole?.isActive !== null ? domain?.userRole?.isActive ? '' : 'denied-domain' : ''}`} key={domain.id} onClick={() => handleSelectOtherDomain(domain)}>
                          <div className='domain-circle p-0'></div>
                          <div className={`domain-and-owner-name p-0 bg-transparent${selectedDomain?.id === domain?.id ? ' text-white' : ''}`}>
                            <h3> {domain.domainName} </h3>
                            <h4> {domain?.userRole?.role?.name.charAt(0).toUpperCase() + domain?.userRole?.role?.name.slice(1)} </h4>
                          </div>
                          <h3 className='domain-status p-0 mb-0 bg-transparent'>
                            {domain?.userRole?.isInvited
                              ? domain?.userRole?.isActive
                                ? <button onClick={selectedDomain?.id === domain?.id ? () => handleStartDomain('launch') : () => { }}> Launch </button>
                                : domain?.userRole?.isActive === null ?
                                  selectedDomain?.id === domain?.id ?
                                    <div className='flex flex-column'>
                                      <button className="accept-and-launch-domain" onClick={selectedDomain?.id === domain?.id ? () => handleStartDomain('accept-and-launch') : () => { }}> Accept and Launch </button>
                                      <button className="reject-domain" onClick={selectedDomain?.id === domain?.id ? () => handleStartDomain('reject') : () => { }}> Reject </button>
                                    </div>
                                    : 'Pending'
                                  : 'Rejected'
                              : domain?.userRole?.isActive !== null
                                ? domain?.userRole?.isActive ?
                                  <button onClick={selectedDomain?.id === domain?.id ? () => handleStartDomain('launch') : () => { }}> Launch </button>
                                  : 'Denied'
                                // : domain?.userRole?.role?.name.charAt(0).toUpperCase() + domain?.userRole?.role?.name.slice(1)}
                                : 'Joining'}
                          </h3>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        step === 'create' && (
          <div className="create-domain">
            <div className="title flex align-center justify-end">
              <h3
                className="select-domain-btn fw-bold"
                onClick={() => setStep('select')}
              >
                Select Domain
              </h3>
            </div>
            <div className="create-domain-inner">
              <h3 className="create-new-domain">Create New Domain</h3>
              {
                createStep === 'basic' && (
                  <div className="domain-name">
                    <div className="row align-center gap-2">
                      <div className='item pe-0 w-50'>
                        {/* <input type="text" value={domainNameValues.domainName} onChange={e => setDomainName(e.target.value)} /> */}
                        <input type="text" className={`${domainNameValues.domainNameError ? 'error-border' : ''}`} value={domainNameValues.domainName} onChange={handleDomainNameChange} />
                      </div>
                      <h3 className='w-auto'> @ricochetapp.io </h3>
                    </div>
                    {domainNameValues.domainNameError && (
                      <>
                        <div className='error-container flex align-center'>
                          <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                          <p className='error mb-2'>{domainNameValues.domainNameError}</p>
                        </div>
                        {existingDomainInfo.isAlreadyJoined && (
                          <p className='notify-admin-message h4'> Do you wish to notify the Admin that you would like to join this domain? </p>
                        )}
                      </>
                    )}
                  </div>
                )
              }
              {
                isShowPromt && (
                  <div className="prompt">
                    <h5>Here is existing domain</h5>
                    <div className="row">
                      <div className="item">
                        <div>Company Name: </div>
                        <input type="text" disabled value={existingDomainInfo?.existingDomain?.companyName} />
                      </div>
                      <div className="item action">
                        <button type="button" className="btn btn-blue" onClick={() => handleExistingDomain(existingDomainInfo?.existingDomain)}>
                          Join
                        </button>
                        <button type="button" className="btn btn-red" onClick={handleTryAnother}>
                          Try new
                        </button>
                      </div>
                    </div>
                  </div>
                )
              }
              {
                createStep === 'final' && (
                  <div className="content final-step">
                    <div className="row g-0 flex-wrap flex-md-nowrap">
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Domain Name: </div>
                        <input type="text" disabled value={domainNameValues.domainName} onChange={handleDomainNameChange} />
                      </div>
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Company Name: </div>
                        <input type="text" value={companyName} onChange={e => setCompanyName(e.target.value)} />
                      </div>
                    </div>
                    <div className="row g-0 flex-wrap flex-md-nowrap">
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Address 1: </div>
                        <input type="text" value={address1} onChange={e => setAddress1(e.target.value)} />
                      </div>
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Address 2: </div>
                        <input type="text" value={address2} onChange={e => setAddress2(e.target.value)} />
                      </div>
                    </div>
                    <div className="row g-0 flex-wrap flex-md-nowrap">
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>City: </div>
                        <input type="text" value={city} onChange={e => setCity(e.target.value)} />
                      </div>
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>State: </div>
                        <input type="text" value={state} onChange={e => setState(e.target.value)} />
                      </div>
                    </div>
                    <div className="row g-0 flex-wrap flex-md-nowrap">
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Zip: </div>
                        <input type="text" value={zip} onChange={e => setZip(e.target.value)} />
                      </div>
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Country: </div>
                        <input type="text" value={country} onChange={e => setCountry(e.target.value)} />
                      </div>
                    </div>
                    <div className="row g-0 flex-wrap flex-md-nowrap">
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Url: </div>
                        <input type="text" value={url} onChange={e => setUrl(e.target.value)} />
                      </div>
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Phone: </div>
                        <input type="text" value={phone} onChange={e => setPhone(e.target.value)} />
                      </div>
                    </div>
                    <div className="row g-0 flex-wrap flex-md-nowrap">
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Industry: </div>
                        <input type="text" value={industry} onChange={e => setIndustry(e.target.value)} />
                      </div>
                      <div className='item flex-grow-1 flex-shrink-1'>
                        <div className='h4'>Company Size: </div>
                        <input type="text" value={companySize} onChange={e => setCompanySize(e.target.value)} />
                      </div>
                    </div>
                  </div>
                )
              }
              <div className={`action row g-0 flex-wrap flex-md-nowrap `}>
                {
                  createStep === 'final' && (
                    <button type="button" disabled={isComponnetLoading} className="btn btn-try-new-domain btn-blue flex-grow-1 flex-shrink-1 ps-0 pe-0 mt-0" onClick={handleTryAnother}>
                      Try New Domain
                    </button>
                  )
                }
                {
                  !isShowPromt && (
                    existingDomainInfo.isAlreadyJoined ?
                      <button type="button" disabled={isComponnetLoading} className="btn btn-notify-domain w-auto mt-0" onClick={() => { }}>Notify</button>
                      :
                      <button type="button" disabled={isComponnetLoading} className={`btn btn-create-domain mt-0 ${createStep === 'final' ? 'final-step flex-grow-1 flex-shrink-1 ps-0 pe-0' : 'w-auto'}`} onClick={handleCreateDomain}>Create</button>
                  )
                }
              </div>
            </div>
          </div>
        )
      }
    </div>
  )
}

export default DomainSelector